import { render, staticRenderFns } from "./EntityList.vue?vue&type=template&id=36396ddc&scoped=true"
import script from "./EntityList.vue?vue&type=script&lang=js"
export * from "./EntityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36396ddc",
  null
  
)

export default component.exports